import Warranty from "./warranty.container";

export default Warranty;
